'use client'

import { ResponsiveImage } from '@susu/headless-commerce/components/ResponsiveImage/ResponsiveImage'
import { generateImageSourcesForCloudinary } from '@susu/headless-commerce/components/ResponsiveImage/utils'
import type { NavigationCard } from '@susu/headless-commerce/features/navigation/domain/NavigationCard'
import { useMemo } from 'react'

export type ClientNavCardProps = {
  item: NavigationCard
}

export const ClientNavCard = ({ item }: ClientNavCardProps) => {
  const { image } = item

  const {
    desktopSrcSet,
    mobileSrcSet,
    tabletSrcSet,
    desktopSizes,
    mobileSizes,
    tabletSizes,
    smallestUrl,
  } = useMemo(
    () =>
      generateImageSourcesForCloudinary(
        {
          cloudinaryDesktopImage: image?.cloudinaryDesktopImage,
          cloudinaryMobileImage: image?.cloudinaryMobileImage,
          cloudinaryTabletImage: image?.cloudinaryTabletImage,
        },
        {
          xs: '100vw',
          md: '45vw',
          lg: '30vw',
        },
      ),
    [
      image?.cloudinaryDesktopImage,
      image?.cloudinaryMobileImage,
      image?.cloudinaryTabletImage,
    ],
  )

  return (
    <ResponsiveImage
      alt={image?.altText ?? ''}
      desktopSizes={desktopSizes}
      desktopSrcSet={desktopSrcSet}
      tabletSrcSet={tabletSrcSet}
      tabletSizes={tabletSizes}
      mobileSrcSet={mobileSrcSet}
      mobileSizes={mobileSizes}
      src={smallestUrl}
      lazyloading={image?.lazyloading ?? true}
    />
  )
}
